/* tslint:disable */
/* eslint-disable */
/**
 * TurboClaim API
 * TurboClaim API for insurance claim management. Includes claims, documents, estimates, supplements, billing, and chat operations. Authentication is JWT-based bearer token. 
 *
 * The version of the OpenAPI document: 1.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  CreateEmailMatchRuleRequest,
  CreateEmailMatchRuleResponse,
  GetClaimEmailResponse,
  GmailAuthUrlResponse,
  GmailDisconnectResponse,
  GmailStatusResponse,
  ImportGmailThreadRequest,
  ImportGmailThreadResponse,
  ListClaimEmailsResponse,
  ListEmailMatchRulesResponse,
  Problem,
  SearchGmailThreadsResponse,
  SendClaimEmailRequest,
  SendClaimEmailResponse,
  SyncClaimEmailsResponse,
} from '../models/index';
import {
    CreateEmailMatchRuleRequestFromJSON,
    CreateEmailMatchRuleRequestToJSON,
    CreateEmailMatchRuleResponseFromJSON,
    CreateEmailMatchRuleResponseToJSON,
    GetClaimEmailResponseFromJSON,
    GetClaimEmailResponseToJSON,
    GmailAuthUrlResponseFromJSON,
    GmailAuthUrlResponseToJSON,
    GmailDisconnectResponseFromJSON,
    GmailDisconnectResponseToJSON,
    GmailStatusResponseFromJSON,
    GmailStatusResponseToJSON,
    ImportGmailThreadRequestFromJSON,
    ImportGmailThreadRequestToJSON,
    ImportGmailThreadResponseFromJSON,
    ImportGmailThreadResponseToJSON,
    ListClaimEmailsResponseFromJSON,
    ListClaimEmailsResponseToJSON,
    ListEmailMatchRulesResponseFromJSON,
    ListEmailMatchRulesResponseToJSON,
    ProblemFromJSON,
    ProblemToJSON,
    SearchGmailThreadsResponseFromJSON,
    SearchGmailThreadsResponseToJSON,
    SendClaimEmailRequestFromJSON,
    SendClaimEmailRequestToJSON,
    SendClaimEmailResponseFromJSON,
    SendClaimEmailResponseToJSON,
    SyncClaimEmailsResponseFromJSON,
    SyncClaimEmailsResponseToJSON,
} from '../models/index';

export interface CreateEmailMatchRuleOperationRequest {
    claimId: number;
    createEmailMatchRuleRequest: CreateEmailMatchRuleRequest;
}

export interface DeleteClaimEmailRequest {
    claimId: number;
    emailId: number;
}

export interface DeleteEmailMatchRuleRequest {
    claimId: number;
    ruleId: number;
}

export interface GetClaimEmailRequest {
    claimId: number;
    emailId: number;
}

export interface GetClaimEmailAttachmentContentRequest {
    claimId: number;
    emailId: number;
    attachmentId: number;
}

export interface GetGmailAuthUrlRequest {
    redirectUrl?: string;
}

export interface GetGmailStatusRequest {
    includeSignature?: boolean;
}

export interface HandleGmailOAuthCallbackRequest {
    code?: string;
    state?: string;
    error?: string;
}

export interface ImportGmailThreadOperationRequest {
    claimId: number;
    importGmailThreadRequest: ImportGmailThreadRequest;
}

export interface ListClaimEmailsRequest {
    claimId: number;
    limit?: number;
    offset?: number;
}

export interface ListEmailMatchRulesRequest {
    claimId: number;
}

export interface SearchGmailThreadsRequest {
    claimId: number;
    q: string;
    maxResults?: number;
    pageToken?: string;
}

export interface SendClaimEmailOperationRequest {
    claimId: number;
    sendClaimEmailRequest: SendClaimEmailRequest;
}

export interface SyncClaimEmailsRequest {
    claimId: number;
}

/**
 * GmailApi - interface
 * 
 * @export
 * @interface GmailApiInterface
 */
export interface GmailApiInterface {
    /**
     * 
     * @summary Add an auto-import rule to a claim
     * @param {number} claimId Claim ID
     * @param {CreateEmailMatchRuleRequest} createEmailMatchRuleRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof GmailApiInterface
     */
    createEmailMatchRuleRaw(requestParameters: CreateEmailMatchRuleOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<CreateEmailMatchRuleResponse>>;

    /**
     * Add an auto-import rule to a claim
     */
    createEmailMatchRule(requestParameters: CreateEmailMatchRuleOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<CreateEmailMatchRuleResponse>;

    /**
     * Removes an email from the claim\'s email list. The email record is retained server-side so its Gmail message ID still dedups auto-import — a dismissed email is never resurrected by a later sync. 
     * @summary Dismiss (soft-delete) an email from a claim
     * @param {number} claimId Claim ID
     * @param {number} emailId Email ID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof GmailApiInterface
     */
    deleteClaimEmailRaw(requestParameters: DeleteClaimEmailRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>>;

    /**
     * Removes an email from the claim\'s email list. The email record is retained server-side so its Gmail message ID still dedups auto-import — a dismissed email is never resurrected by a later sync. 
     * Dismiss (soft-delete) an email from a claim
     */
    deleteClaimEmail(requestParameters: DeleteClaimEmailRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void>;

    /**
     * 
     * @summary Remove an auto-import rule from a claim
     * @param {number} claimId Claim ID
     * @param {number} ruleId Rule ID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof GmailApiInterface
     */
    deleteEmailMatchRuleRaw(requestParameters: DeleteEmailMatchRuleRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>>;

    /**
     * Remove an auto-import rule from a claim
     */
    deleteEmailMatchRule(requestParameters: DeleteEmailMatchRuleRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void>;

    /**
     * Disconnects the user\'s linked Gmail account and revokes tokens.
     * @summary Disconnect Gmail account
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof GmailApiInterface
     */
    disconnectGmailRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GmailDisconnectResponse>>;

    /**
     * Disconnects the user\'s linked Gmail account and revokes tokens.
     * Disconnect Gmail account
     */
    disconnectGmail(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GmailDisconnectResponse>;

    /**
     * Get a single email with recipients, associated with a claim.
     * @summary Get a specific email by ID
     * @param {number} claimId Claim ID
     * @param {number} emailId Email ID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof GmailApiInterface
     */
    getClaimEmailRaw(requestParameters: GetClaimEmailRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetClaimEmailResponse>>;

    /**
     * Get a single email with recipients, associated with a claim.
     * Get a specific email by ID
     */
    getClaimEmail(requestParameters: GetClaimEmailRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetClaimEmailResponse>;

    /**
     * 
     * @summary Download an attachment from a claim email
     * @param {number} claimId 
     * @param {number} emailId 
     * @param {number} attachmentId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof GmailApiInterface
     */
    getClaimEmailAttachmentContentRaw(requestParameters: GetClaimEmailAttachmentContentRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Blob>>;

    /**
     * Download an attachment from a claim email
     */
    getClaimEmailAttachmentContent(requestParameters: GetClaimEmailAttachmentContentRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Blob>;

    /**
     * Generates a Google OAuth2 authorization URL. Frontend should redirect the user to this URL to connect their Gmail account.
     * @summary Get Gmail OAuth authorization URL
     * @param {string} [redirectUrl] Optional frontend URL to redirect to after OAuth completes
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof GmailApiInterface
     */
    getGmailAuthUrlRaw(requestParameters: GetGmailAuthUrlRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GmailAuthUrlResponse>>;

    /**
     * Generates a Google OAuth2 authorization URL. Frontend should redirect the user to this URL to connect their Gmail account.
     * Get Gmail OAuth authorization URL
     */
    getGmailAuthUrl(requestParameters: GetGmailAuthUrlRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GmailAuthUrlResponse>;

    /**
     * Returns whether the current user has a connected Gmail account, and if so, the account details (no tokens exposed).
     * @summary Get Gmail connection status
     * @param {boolean} [includeSignature] Include compose signature fields by performing a send-as settings lookup. Disabled by default to avoid extra Gmail API calls.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof GmailApiInterface
     */
    getGmailStatusRaw(requestParameters: GetGmailStatusRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GmailStatusResponse>>;

    /**
     * Returns whether the current user has a connected Gmail account, and if so, the account details (no tokens exposed).
     * Get Gmail connection status
     */
    getGmailStatus(requestParameters: GetGmailStatusRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GmailStatusResponse>;

    /**
     * Handles the OAuth2 callback from Google after the user authorizes Gmail access. Exchanges the authorization code for tokens, stores them, and redirects the user back to the frontend with a success or error query parameter. This endpoint does NOT require authentication — the user is redirected here by Google. 
     * @summary Handle Gmail OAuth callback
     * @param {string} [code] Authorization code from Google
     * @param {string} [state] State parameter containing user/company info
     * @param {string} [error] Error code if the user denied access
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof GmailApiInterface
     */
    handleGmailOAuthCallbackRaw(requestParameters: HandleGmailOAuthCallbackRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>>;

    /**
     * Handles the OAuth2 callback from Google after the user authorizes Gmail access. Exchanges the authorization code for tokens, stores them, and redirects the user back to the frontend with a success or error query parameter. This endpoint does NOT require authentication — the user is redirected here by Google. 
     * Handle Gmail OAuth callback
     */
    handleGmailOAuthCallback(requestParameters: HandleGmailOAuthCallbackRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void>;

    /**
     * Import one or more Gmail messages from a thread into the current claim. Uses claim-scoped deduplication to prevent importing the same message multiple times to the same claim. Can import an entire thread or specific messages from a thread. 
     * @summary Import Gmail thread to claim
     * @param {number} claimId ID of the claim to import into
     * @param {ImportGmailThreadRequest} importGmailThreadRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof GmailApiInterface
     */
    importGmailThreadRaw(requestParameters: ImportGmailThreadOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ImportGmailThreadResponse>>;

    /**
     * Import one or more Gmail messages from a thread into the current claim. Uses claim-scoped deduplication to prevent importing the same message multiple times to the same claim. Can import an entire thread or specific messages from a thread. 
     * Import Gmail thread to claim
     */
    importGmailThread(requestParameters: ImportGmailThreadOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ImportGmailThreadResponse>;

    /**
     * Get all emails associated with a claim, including recipients.
     * @summary List emails for a claim
     * @param {number} claimId Claim ID
     * @param {number} [limit] Maximum number of emails to return
     * @param {number} [offset] Number of emails to skip
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof GmailApiInterface
     */
    listClaimEmailsRaw(requestParameters: ListClaimEmailsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ListClaimEmailsResponse>>;

    /**
     * Get all emails associated with a claim, including recipients.
     * List emails for a claim
     */
    listClaimEmails(requestParameters: ListClaimEmailsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ListClaimEmailsResponse>;

    /**
     * Lists the claim\'s email auto-import rules. Emails sent from or to a watched address, or whose subject contains a watched term, are automatically imported into the claim on the next email sync. 
     * @summary List auto-import rules for a claim
     * @param {number} claimId Claim ID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof GmailApiInterface
     */
    listEmailMatchRulesRaw(requestParameters: ListEmailMatchRulesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ListEmailMatchRulesResponse>>;

    /**
     * Lists the claim\'s email auto-import rules. Emails sent from or to a watched address, or whose subject contains a watched term, are automatically imported into the claim on the next email sync. 
     * List auto-import rules for a claim
     */
    listEmailMatchRules(requestParameters: ListEmailMatchRulesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ListEmailMatchRulesResponse>;

    /**
     * Search the user\'s Gmail for threads matching a query string. Uses the same syntax as Gmail\'s native search bar (supports from:, to:, subject:, etc.). Returns thread previews with message summaries and claim-scoped import status.  **Important**: The `alreadyImported` flag indicates whether a message has been  imported to THIS specific claim, matching the behavior of the import endpoint  which uses claim-scoped deduplication. 
     * @summary Search Gmail threads (claim-scoped)
     * @param {number} claimId ID of the claim to check import status against
     * @param {string} q Gmail search query (same syntax as Gmail search bar)
     * @param {number} [maxResults] Maximum number of threads to return
     * @param {string} [pageToken] Token for fetching next page of results
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof GmailApiInterface
     */
    searchGmailThreadsRaw(requestParameters: SearchGmailThreadsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<SearchGmailThreadsResponse>>;

    /**
     * Search the user\'s Gmail for threads matching a query string. Uses the same syntax as Gmail\'s native search bar (supports from:, to:, subject:, etc.). Returns thread previews with message summaries and claim-scoped import status.  **Important**: The `alreadyImported` flag indicates whether a message has been  imported to THIS specific claim, matching the behavior of the import endpoint  which uses claim-scoped deduplication. 
     * Search Gmail threads (claim-scoped)
     */
    searchGmailThreads(requestParameters: SearchGmailThreadsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<SearchGmailThreadsResponse>;

    /**
     * Sends an email from the user\'s connected Gmail account, linked to a claim. The email is recorded in the claim\'s email history and an activity event is published. At least one of bodyText or bodyHtml must be provided. 
     * @summary Send an email from a claim via Gmail
     * @param {number} claimId Claim ID
     * @param {SendClaimEmailRequest} sendClaimEmailRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof GmailApiInterface
     */
    sendClaimEmailRaw(requestParameters: SendClaimEmailOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<SendClaimEmailResponse>>;

    /**
     * Sends an email from the user\'s connected Gmail account, linked to a claim. The email is recorded in the claim\'s email history and an activity event is published. At least one of bodyText or bodyHtml must be provided. 
     * Send an email from a claim via Gmail
     */
    sendClaimEmail(requestParameters: SendClaimEmailOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<SendClaimEmailResponse>;

    /**
     * Checks all Gmail threads associated with this claim for new messages (replies). Any new messages are imported into the claim\'s email history as inbound emails. Requires gmail.readonly scope. User may need to re-connect Gmail if scope was not previously granted. 
     * @summary Sync email replies from Gmail
     * @param {number} claimId Claim ID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof GmailApiInterface
     */
    syncClaimEmailsRaw(requestParameters: SyncClaimEmailsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<SyncClaimEmailsResponse>>;

    /**
     * Checks all Gmail threads associated with this claim for new messages (replies). Any new messages are imported into the claim\'s email history as inbound emails. Requires gmail.readonly scope. User may need to re-connect Gmail if scope was not previously granted. 
     * Sync email replies from Gmail
     */
    syncClaimEmails(requestParameters: SyncClaimEmailsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<SyncClaimEmailsResponse>;

}

/**
 * 
 */
export class GmailApi extends runtime.BaseAPI implements GmailApiInterface {

    /**
     * Add an auto-import rule to a claim
     */
    async createEmailMatchRuleRaw(requestParameters: CreateEmailMatchRuleOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<CreateEmailMatchRuleResponse>> {
        if (requestParameters['claimId'] == null) {
            throw new runtime.RequiredError(
                'claimId',
                'Required parameter "claimId" was null or undefined when calling createEmailMatchRule().'
            );
        }

        if (requestParameters['createEmailMatchRuleRequest'] == null) {
            throw new runtime.RequiredError(
                'createEmailMatchRuleRequest',
                'Required parameter "createEmailMatchRuleRequest" was null or undefined when calling createEmailMatchRule().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/claims/{claimId}/emails/match-rules`.replace(`{${"claimId"}}`, encodeURIComponent(String(requestParameters['claimId']))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: CreateEmailMatchRuleRequestToJSON(requestParameters['createEmailMatchRuleRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => CreateEmailMatchRuleResponseFromJSON(jsonValue));
    }

    /**
     * Add an auto-import rule to a claim
     */
    async createEmailMatchRule(requestParameters: CreateEmailMatchRuleOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<CreateEmailMatchRuleResponse> {
        const response = await this.createEmailMatchRuleRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Removes an email from the claim\'s email list. The email record is retained server-side so its Gmail message ID still dedups auto-import — a dismissed email is never resurrected by a later sync. 
     * Dismiss (soft-delete) an email from a claim
     */
    async deleteClaimEmailRaw(requestParameters: DeleteClaimEmailRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['claimId'] == null) {
            throw new runtime.RequiredError(
                'claimId',
                'Required parameter "claimId" was null or undefined when calling deleteClaimEmail().'
            );
        }

        if (requestParameters['emailId'] == null) {
            throw new runtime.RequiredError(
                'emailId',
                'Required parameter "emailId" was null or undefined when calling deleteClaimEmail().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/claims/{claimId}/emails/{emailId}`.replace(`{${"claimId"}}`, encodeURIComponent(String(requestParameters['claimId']))).replace(`{${"emailId"}}`, encodeURIComponent(String(requestParameters['emailId']))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Removes an email from the claim\'s email list. The email record is retained server-side so its Gmail message ID still dedups auto-import — a dismissed email is never resurrected by a later sync. 
     * Dismiss (soft-delete) an email from a claim
     */
    async deleteClaimEmail(requestParameters: DeleteClaimEmailRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.deleteClaimEmailRaw(requestParameters, initOverrides);
    }

    /**
     * Remove an auto-import rule from a claim
     */
    async deleteEmailMatchRuleRaw(requestParameters: DeleteEmailMatchRuleRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['claimId'] == null) {
            throw new runtime.RequiredError(
                'claimId',
                'Required parameter "claimId" was null or undefined when calling deleteEmailMatchRule().'
            );
        }

        if (requestParameters['ruleId'] == null) {
            throw new runtime.RequiredError(
                'ruleId',
                'Required parameter "ruleId" was null or undefined when calling deleteEmailMatchRule().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/claims/{claimId}/emails/match-rules/{ruleId}`.replace(`{${"claimId"}}`, encodeURIComponent(String(requestParameters['claimId']))).replace(`{${"ruleId"}}`, encodeURIComponent(String(requestParameters['ruleId']))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Remove an auto-import rule from a claim
     */
    async deleteEmailMatchRule(requestParameters: DeleteEmailMatchRuleRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.deleteEmailMatchRuleRaw(requestParameters, initOverrides);
    }

    /**
     * Disconnects the user\'s linked Gmail account and revokes tokens.
     * Disconnect Gmail account
     */
    async disconnectGmailRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GmailDisconnectResponse>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/gmail/disconnect`,
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GmailDisconnectResponseFromJSON(jsonValue));
    }

    /**
     * Disconnects the user\'s linked Gmail account and revokes tokens.
     * Disconnect Gmail account
     */
    async disconnectGmail(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GmailDisconnectResponse> {
        const response = await this.disconnectGmailRaw(initOverrides);
        return await response.value();
    }

    /**
     * Get a single email with recipients, associated with a claim.
     * Get a specific email by ID
     */
    async getClaimEmailRaw(requestParameters: GetClaimEmailRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetClaimEmailResponse>> {
        if (requestParameters['claimId'] == null) {
            throw new runtime.RequiredError(
                'claimId',
                'Required parameter "claimId" was null or undefined when calling getClaimEmail().'
            );
        }

        if (requestParameters['emailId'] == null) {
            throw new runtime.RequiredError(
                'emailId',
                'Required parameter "emailId" was null or undefined when calling getClaimEmail().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/claims/{claimId}/emails/{emailId}`.replace(`{${"claimId"}}`, encodeURIComponent(String(requestParameters['claimId']))).replace(`{${"emailId"}}`, encodeURIComponent(String(requestParameters['emailId']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GetClaimEmailResponseFromJSON(jsonValue));
    }

    /**
     * Get a single email with recipients, associated with a claim.
     * Get a specific email by ID
     */
    async getClaimEmail(requestParameters: GetClaimEmailRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetClaimEmailResponse> {
        const response = await this.getClaimEmailRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Download an attachment from a claim email
     */
    async getClaimEmailAttachmentContentRaw(requestParameters: GetClaimEmailAttachmentContentRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Blob>> {
        if (requestParameters['claimId'] == null) {
            throw new runtime.RequiredError(
                'claimId',
                'Required parameter "claimId" was null or undefined when calling getClaimEmailAttachmentContent().'
            );
        }

        if (requestParameters['emailId'] == null) {
            throw new runtime.RequiredError(
                'emailId',
                'Required parameter "emailId" was null or undefined when calling getClaimEmailAttachmentContent().'
            );
        }

        if (requestParameters['attachmentId'] == null) {
            throw new runtime.RequiredError(
                'attachmentId',
                'Required parameter "attachmentId" was null or undefined when calling getClaimEmailAttachmentContent().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/claims/{claimId}/emails/{emailId}/attachments/{attachmentId}/content`.replace(`{${"claimId"}}`, encodeURIComponent(String(requestParameters['claimId']))).replace(`{${"emailId"}}`, encodeURIComponent(String(requestParameters['emailId']))).replace(`{${"attachmentId"}}`, encodeURIComponent(String(requestParameters['attachmentId']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.BlobApiResponse(response);
    }

    /**
     * Download an attachment from a claim email
     */
    async getClaimEmailAttachmentContent(requestParameters: GetClaimEmailAttachmentContentRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Blob> {
        const response = await this.getClaimEmailAttachmentContentRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Generates a Google OAuth2 authorization URL. Frontend should redirect the user to this URL to connect their Gmail account.
     * Get Gmail OAuth authorization URL
     */
    async getGmailAuthUrlRaw(requestParameters: GetGmailAuthUrlRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GmailAuthUrlResponse>> {
        const queryParameters: any = {};

        if (requestParameters['redirectUrl'] != null) {
            queryParameters['redirectUrl'] = requestParameters['redirectUrl'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/gmail/auth-url`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GmailAuthUrlResponseFromJSON(jsonValue));
    }

    /**
     * Generates a Google OAuth2 authorization URL. Frontend should redirect the user to this URL to connect their Gmail account.
     * Get Gmail OAuth authorization URL
     */
    async getGmailAuthUrl(requestParameters: GetGmailAuthUrlRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GmailAuthUrlResponse> {
        const response = await this.getGmailAuthUrlRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Returns whether the current user has a connected Gmail account, and if so, the account details (no tokens exposed).
     * Get Gmail connection status
     */
    async getGmailStatusRaw(requestParameters: GetGmailStatusRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GmailStatusResponse>> {
        const queryParameters: any = {};

        if (requestParameters['includeSignature'] != null) {
            queryParameters['includeSignature'] = requestParameters['includeSignature'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/gmail/status`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GmailStatusResponseFromJSON(jsonValue));
    }

    /**
     * Returns whether the current user has a connected Gmail account, and if so, the account details (no tokens exposed).
     * Get Gmail connection status
     */
    async getGmailStatus(requestParameters: GetGmailStatusRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GmailStatusResponse> {
        const response = await this.getGmailStatusRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Handles the OAuth2 callback from Google after the user authorizes Gmail access. Exchanges the authorization code for tokens, stores them, and redirects the user back to the frontend with a success or error query parameter. This endpoint does NOT require authentication — the user is redirected here by Google. 
     * Handle Gmail OAuth callback
     */
    async handleGmailOAuthCallbackRaw(requestParameters: HandleGmailOAuthCallbackRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        const queryParameters: any = {};

        if (requestParameters['code'] != null) {
            queryParameters['code'] = requestParameters['code'];
        }

        if (requestParameters['state'] != null) {
            queryParameters['state'] = requestParameters['state'];
        }

        if (requestParameters['error'] != null) {
            queryParameters['error'] = requestParameters['error'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/gmail/oauth/callback`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Handles the OAuth2 callback from Google after the user authorizes Gmail access. Exchanges the authorization code for tokens, stores them, and redirects the user back to the frontend with a success or error query parameter. This endpoint does NOT require authentication — the user is redirected here by Google. 
     * Handle Gmail OAuth callback
     */
    async handleGmailOAuthCallback(requestParameters: HandleGmailOAuthCallbackRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.handleGmailOAuthCallbackRaw(requestParameters, initOverrides);
    }

    /**
     * Import one or more Gmail messages from a thread into the current claim. Uses claim-scoped deduplication to prevent importing the same message multiple times to the same claim. Can import an entire thread or specific messages from a thread. 
     * Import Gmail thread to claim
     */
    async importGmailThreadRaw(requestParameters: ImportGmailThreadOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ImportGmailThreadResponse>> {
        if (requestParameters['claimId'] == null) {
            throw new runtime.RequiredError(
                'claimId',
                'Required parameter "claimId" was null or undefined when calling importGmailThread().'
            );
        }

        if (requestParameters['importGmailThreadRequest'] == null) {
            throw new runtime.RequiredError(
                'importGmailThreadRequest',
                'Required parameter "importGmailThreadRequest" was null or undefined when calling importGmailThread().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/claims/{claimId}/gmail/import`.replace(`{${"claimId"}}`, encodeURIComponent(String(requestParameters['claimId']))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: ImportGmailThreadRequestToJSON(requestParameters['importGmailThreadRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ImportGmailThreadResponseFromJSON(jsonValue));
    }

    /**
     * Import one or more Gmail messages from a thread into the current claim. Uses claim-scoped deduplication to prevent importing the same message multiple times to the same claim. Can import an entire thread or specific messages from a thread. 
     * Import Gmail thread to claim
     */
    async importGmailThread(requestParameters: ImportGmailThreadOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ImportGmailThreadResponse> {
        const response = await this.importGmailThreadRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get all emails associated with a claim, including recipients.
     * List emails for a claim
     */
    async listClaimEmailsRaw(requestParameters: ListClaimEmailsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ListClaimEmailsResponse>> {
        if (requestParameters['claimId'] == null) {
            throw new runtime.RequiredError(
                'claimId',
                'Required parameter "claimId" was null or undefined when calling listClaimEmails().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['limit'] != null) {
            queryParameters['limit'] = requestParameters['limit'];
        }

        if (requestParameters['offset'] != null) {
            queryParameters['offset'] = requestParameters['offset'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/claims/{claimId}/emails`.replace(`{${"claimId"}}`, encodeURIComponent(String(requestParameters['claimId']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ListClaimEmailsResponseFromJSON(jsonValue));
    }

    /**
     * Get all emails associated with a claim, including recipients.
     * List emails for a claim
     */
    async listClaimEmails(requestParameters: ListClaimEmailsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ListClaimEmailsResponse> {
        const response = await this.listClaimEmailsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Lists the claim\'s email auto-import rules. Emails sent from or to a watched address, or whose subject contains a watched term, are automatically imported into the claim on the next email sync. 
     * List auto-import rules for a claim
     */
    async listEmailMatchRulesRaw(requestParameters: ListEmailMatchRulesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ListEmailMatchRulesResponse>> {
        if (requestParameters['claimId'] == null) {
            throw new runtime.RequiredError(
                'claimId',
                'Required parameter "claimId" was null or undefined when calling listEmailMatchRules().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/claims/{claimId}/emails/match-rules`.replace(`{${"claimId"}}`, encodeURIComponent(String(requestParameters['claimId']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ListEmailMatchRulesResponseFromJSON(jsonValue));
    }

    /**
     * Lists the claim\'s email auto-import rules. Emails sent from or to a watched address, or whose subject contains a watched term, are automatically imported into the claim on the next email sync. 
     * List auto-import rules for a claim
     */
    async listEmailMatchRules(requestParameters: ListEmailMatchRulesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ListEmailMatchRulesResponse> {
        const response = await this.listEmailMatchRulesRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Search the user\'s Gmail for threads matching a query string. Uses the same syntax as Gmail\'s native search bar (supports from:, to:, subject:, etc.). Returns thread previews with message summaries and claim-scoped import status.  **Important**: The `alreadyImported` flag indicates whether a message has been  imported to THIS specific claim, matching the behavior of the import endpoint  which uses claim-scoped deduplication. 
     * Search Gmail threads (claim-scoped)
     */
    async searchGmailThreadsRaw(requestParameters: SearchGmailThreadsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<SearchGmailThreadsResponse>> {
        if (requestParameters['claimId'] == null) {
            throw new runtime.RequiredError(
                'claimId',
                'Required parameter "claimId" was null or undefined when calling searchGmailThreads().'
            );
        }

        if (requestParameters['q'] == null) {
            throw new runtime.RequiredError(
                'q',
                'Required parameter "q" was null or undefined when calling searchGmailThreads().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['q'] != null) {
            queryParameters['q'] = requestParameters['q'];
        }

        if (requestParameters['maxResults'] != null) {
            queryParameters['maxResults'] = requestParameters['maxResults'];
        }

        if (requestParameters['pageToken'] != null) {
            queryParameters['pageToken'] = requestParameters['pageToken'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/claims/{claimId}/gmail/search`.replace(`{${"claimId"}}`, encodeURIComponent(String(requestParameters['claimId']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => SearchGmailThreadsResponseFromJSON(jsonValue));
    }

    /**
     * Search the user\'s Gmail for threads matching a query string. Uses the same syntax as Gmail\'s native search bar (supports from:, to:, subject:, etc.). Returns thread previews with message summaries and claim-scoped import status.  **Important**: The `alreadyImported` flag indicates whether a message has been  imported to THIS specific claim, matching the behavior of the import endpoint  which uses claim-scoped deduplication. 
     * Search Gmail threads (claim-scoped)
     */
    async searchGmailThreads(requestParameters: SearchGmailThreadsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<SearchGmailThreadsResponse> {
        const response = await this.searchGmailThreadsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Sends an email from the user\'s connected Gmail account, linked to a claim. The email is recorded in the claim\'s email history and an activity event is published. At least one of bodyText or bodyHtml must be provided. 
     * Send an email from a claim via Gmail
     */
    async sendClaimEmailRaw(requestParameters: SendClaimEmailOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<SendClaimEmailResponse>> {
        if (requestParameters['claimId'] == null) {
            throw new runtime.RequiredError(
                'claimId',
                'Required parameter "claimId" was null or undefined when calling sendClaimEmail().'
            );
        }

        if (requestParameters['sendClaimEmailRequest'] == null) {
            throw new runtime.RequiredError(
                'sendClaimEmailRequest',
                'Required parameter "sendClaimEmailRequest" was null or undefined when calling sendClaimEmail().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/claims/{claimId}/emails/send`.replace(`{${"claimId"}}`, encodeURIComponent(String(requestParameters['claimId']))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: SendClaimEmailRequestToJSON(requestParameters['sendClaimEmailRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => SendClaimEmailResponseFromJSON(jsonValue));
    }

    /**
     * Sends an email from the user\'s connected Gmail account, linked to a claim. The email is recorded in the claim\'s email history and an activity event is published. At least one of bodyText or bodyHtml must be provided. 
     * Send an email from a claim via Gmail
     */
    async sendClaimEmail(requestParameters: SendClaimEmailOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<SendClaimEmailResponse> {
        const response = await this.sendClaimEmailRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Checks all Gmail threads associated with this claim for new messages (replies). Any new messages are imported into the claim\'s email history as inbound emails. Requires gmail.readonly scope. User may need to re-connect Gmail if scope was not previously granted. 
     * Sync email replies from Gmail
     */
    async syncClaimEmailsRaw(requestParameters: SyncClaimEmailsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<SyncClaimEmailsResponse>> {
        if (requestParameters['claimId'] == null) {
            throw new runtime.RequiredError(
                'claimId',
                'Required parameter "claimId" was null or undefined when calling syncClaimEmails().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/claims/{claimId}/emails/sync`.replace(`{${"claimId"}}`, encodeURIComponent(String(requestParameters['claimId']))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => SyncClaimEmailsResponseFromJSON(jsonValue));
    }

    /**
     * Checks all Gmail threads associated with this claim for new messages (replies). Any new messages are imported into the claim\'s email history as inbound emails. Requires gmail.readonly scope. User may need to re-connect Gmail if scope was not previously granted. 
     * Sync email replies from Gmail
     */
    async syncClaimEmails(requestParameters: SyncClaimEmailsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<SyncClaimEmailsResponse> {
        const response = await this.syncClaimEmailsRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
